import { useCallback, useEffect, useRef, useState } from 'react'

/** Restart on every successful action, even when the displayed text is identical. */
export function useTransientNotice() {
  const [notice, setNotice] = useState('')
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)
  const showNotice = useCallback((message: string, duration = 3000) => {
    clearTimeout(timer.current)
    timer.current = undefined
    setNotice(message)
    if (message && duration > 0) {
      timer.current = setTimeout(() => {
        timer.current = undefined
        setNotice('')
      }, duration)
    }
  }, [])
  useEffect(() => () => { clearTimeout(timer.current) }, [])
  return [notice, showNotice] as const
}
